var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cnt2"}},[(_vm.is_authenticated)?_c('menu-bar',{key:_vm.menubar_key}):_vm._e(),_c('b-container',{staticStyle:{"margin-top":"70px"},attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }